import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import Offers from 'components/UI/Offers/Offers';

const OffersStyled = withStyles((theme) => ({}))(Offers);

export default OffersStyled;
